import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { CustomizedSnackbar } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { open, message, variant } = state.snackbar
  return ({
    open,
    message,
    variant,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClose: (event, reason) => {
      if (reason === 'clickaway') {
        return
      }
      dispatch(actions.snackbar.close())
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomizedSnackbar)


// WEBPACK FOOTER //
// ./src/containers/Common/Snackbar/CustomizedSnackbar.js